export default __webpack_public_path__ + "static/media/primeicons.e61f3495.woff";